import { AuthenticatedUser, selectAuthenticatedUser, useSelector } from '@missionlabs/api'
import { useFeatureFlags } from '@missionlabs/feature-flags'
import { useCallback, useEffect } from 'react'

export const useFeatureFlagIdentify = () => {
    const { identify, identity, logout } = useFeatureFlags()

    const user = useSelector(selectAuthenticatedUser)

    const identifyUser = useCallback(
        (_user: AuthenticatedUser) => {
            return identify(_user.userID, { clientID: _user.clientID })
        },
        [identify]
    )

    useEffect(() => {
        if (!user) {
            if (identity) void logout()
            return
        }

        if (!identity) identifyUser(user)
    }, [identity, identifyUser, logout, user])
}
